// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9ec80072","239":"bfa66d08","455":"991836ba"}[chunkId] + ".chunk.js";
};